import { RawBenefitsRoot } from './RawBenefits.styles'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { Footer } from 'components/Footer'
import { CtaFooter } from 'features/Home/components/CtaFooter'
import { useObserver } from 'hooks/useObserver'
import { Hero } from './components/Hero'
import { Thrive } from './components/Thrive'
import { NutritionalBenefits } from './components/NutritionalBenefits'
import { DigestiveBenefits } from './components/DigestiveBenefits'
import { AllergyBenefits } from './components/AllergyBenefits'
import { SkinCoatBenefits } from './components/SkinCoatBenefits'
import { UrinaryBenefits } from './components/UrinaryBenefits'
import { WeightLoss } from './components/WeightLoss'
import { PickyEaters } from './components/PickyEaters'
import { Customize } from './components/Customize'
import { Faqs } from './components/Faqs'
import { DentalBenefits } from './components/DentalBenefits'
import { HowToFeedSafely } from './components/HowToFeedSafely'

export const RawBenefits = () => {
  const header = <Header />
  const hideCTA = useObserver({ selector: 'a.cta' })

  return (
    <RawBenefitsRoot>
      <Layout header={header} hideCTA={hideCTA}>
        <Hero />
        <Thrive />
        <NutritionalBenefits />
        <DigestiveBenefits />
        <AllergyBenefits />
        <SkinCoatBenefits />
        <UrinaryBenefits />
        <WeightLoss />
        <DentalBenefits />
        <PickyEaters />
        <HowToFeedSafely />
        <Customize />
        <Faqs />
        <CtaFooter hideSecondaryCta title="raw-benefits:footer.title" />
        <Footer />
      </Layout>
    </RawBenefitsRoot>
  )
}

RawBenefits.displayName = 'RawBenefits'
